<app-base-widget class="relative top-7 md:top-0" [card]="false" attr.data-cy="seriesNavDistributionChart{{portfolioId()}}{{series()?.masterId}}">
    <app-gcm-chart [noMerge]="true" [chartStyle]="cumulativeChartStyle" [chartOptions]="chartConfig" />
</app-base-widget>